import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './NoticeBoradPdfDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import { SERVER_URL } from '../../../../constants/url';
import { useLocation } from 'react-router-dom';

import { Document, Page } from 'react-pdf';
import '../../../../utils/pdfWorker';


// 서버상에서 직접 주소를 참조함으로 설정 처리.. 김하용.
//pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const NoticeBoradPdfDetail = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const location = useLocation();
    const { state } = location;

    // 로컬 기준 99
    //const cntsNttId = state?.cntsNttId ?? 99;

    const [searchNtt, setSearchNtt] = useState({
        cntsNttId: state?.cntsNttId ?? null
        , usrInfoId: user?.usrInfoId ?? null
        , cntsSndngHistId: state?.idx ?? null
        , cnfrmAt: state?.cnfrmAt ?? null
    });

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [contentsInfo, setContentsInfo] = useState({
        cntsSj: "",
    });

    const [src, setSrc] = useState("");

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [loadingPdf, setLoadingPdf] = useState(true);

    const MIN_ZOOM = 0.5;
    const MAX_ZOOM = 3;
    const STEP_ZOOM = 0.1;

    const [zoom, setZoom] = useState(1); // 100%

    const handleZoomIn = () => setZoom(z => Math.min(MAX_ZOOM, +(z + STEP_ZOOM).toFixed(2)));
    const handleZoomOut = () => setZoom(z => Math.max(MIN_ZOOM, +(z - STEP_ZOOM).toFixed(2)));
    const resetZoom = () => setZoom(1);

    const touchStartRef = useRef({ distance: 0, zoom: zoom });

    // Ctrl + 마우스휠로 확대/축소 (PDF 영역에서만)
    const onWheelPdf = (e) => {
        if (e.ctrlKey) {
            e.preventDefault();
            if (e.deltaY > 0) handleZoomOut();
            else handleZoomIn();
        }
    };

    const onLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setLoadingPdf(false);
    };


    // 2) 파일이 바뀔 때만 1페이지로 초기화
    useEffect(() => {
        setPageNumber(1);
    }, [src]);

    const prevPage = () => setPageNumber(p => Math.max(1, p - 1));
    const nextPage = () => setPageNumber(p => Math.min(numPages, p + 1));

    const [viewMode, setViewMode] = useState('continuous'); // 'continuous' | 'single'
    const [pageWidth, setPageWidth] = useState(600);

    const scrollRef = useRef(null);
    const pdfWrapperRef = useRef(null);
    const pinchRef = useRef({
        initialDistance: 0,
        initialZoom: 1,
        centerX: 0,
        centerY: 0
    });

    useEffect(() => {
        if (!searchNtt?.cntsNttId) {
            setToastMessage('잘못 된 접근입니다.');
            setToast(true);
            return;
        }
        getContentsInfo();
    }, [searchNtt?.cntsNttId])

    const getContentsInfo = useCallback(async () => {

        const url = "/homecare/guide/retrieveContentsInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        }

        await axiosApi.post(url, { ...searchNtt }, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {

                    const contInfo = res.data.result.contInfo;

                    const filse = contInfo.fileList;

                    if (filse.length === 0) {
                        setToastMessage('첨부된 파일이 없습니다.');
                        setToast(true);
                        return;
                    }

                    const src = SERVER_URL + `/cmm/fms/getImage?atchFileStr=${filse[0].atchFileStr}&fileSn=${filse[0].fileSn}`;

                    setSrc(src);

                    setContentsInfo(contInfo);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
            })

    }, [searchNtt]);

    // if(!cntsNttId) return null;


    /* 컴포넌트 내부 - 변경/추가된 부분만 발췌 */
    const PAGE_BASE_WIDTH = Math.min(window.innerWidth, 1000); // 필요시 조절 (desktop max width)




    const getDistance = (touches) => {
        const [t1, t2] = touches;
        return Math.hypot(t1.pageX - t2.pageX, t1.pageY - t2.pageY);
    };

    const getCenter = (touches) => {
        const [t1, t2] = touches;
        return {
            x: (t1.pageX + t2.pageX) / 2,
            y: (t1.pageY + t2.pageY) / 2,
        };
    };

    const onTouchStart = (e) => {
        if (e.touches.length === 2) {
            const center = getCenter(e.touches);
            pinchRef.current = {
                initialDistance: getDistance(e.touches),
                initialZoom: zoom,
                centerX: center.x + scrollRef.current.scrollLeft,
                centerY: center.y + scrollRef.current.scrollTop
            };
        }
    };

    const onTouchMove = (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();

            const distance = getDistance(e.touches);
            const newZoom = Math.min(
                MAX_ZOOM,
                Math.max(MIN_ZOOM,
                    pinchRef.current.initialZoom * (distance / pinchRef.current.initialDistance)
                )
            );

            requestAnimationFrame(() => {
                setZoom(newZoom);
            });

            const ratio = newZoom / pinchRef.current.initialZoom;

            setZoom(newZoom);

            // 확대 후 동일한 위치 보정
            const newScrollLeft = pinchRef.current.centerX * ratio - scrollRef.current.clientWidth / 2;
            const newScrollTop = pinchRef.current.centerY * ratio - scrollRef.current.clientHeight / 2;

            scrollRef.current.scrollLeft = newScrollLeft;
            scrollRef.current.scrollTop = newScrollTop;
        }
    };


    return (
        <>
            <HeadSub title="상세 보기" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">

                    <div className={style['top-title-box']}>
                        <strong className={style['title']}>{contentsInfo.cntsSj}</strong>
                        <div className={style['pdf-toolbar']}>
                            <button className='btn' data-btn-type="outline-main" data-btn-size='xsm' data-btn-radius='xxsm' onClick={handleZoomOut} disabled={zoom <= MIN_ZOOM}>
                                <span>－</span>
                            </button>
                            <button className='btn' data-btn-type="outline-main" data-btn-size='xsm' data-btn-radius='xxsm' onClick={handleZoomIn} disabled={zoom >= MAX_ZOOM}>
                                <span>＋</span>
                            </button>
                            <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd' onClick={resetZoom}>
                                <span>100% 보기</span>
                            </button>
                        </div>
                    </div>

                    <div className={style['position-box']}>
                        <div className={style['swiper-wrap-box']}>
                            <div
                                className={style['pdf-container']}
                                onWheel={onWheelPdf}
                                ref={scrollRef}
                            >
                                <div
                                    className={style['pdf-zoom-wrapper']}
                                    style={{
                                        transform: `scale(${zoom})`,
                                        transformOrigin: 'top left',
                                        display: 'inline-block',
                                        width: `${PAGE_BASE_WIDTH * zoom - 45}px`
                                    }}
                                >
                                    <Document
                                        file={src}
                                        onLoadSuccess={onLoadSuccess}
                                        loading="PDF 불러오는 중…"
                                        noData="PDF 불러오는 중…"
                                    >
                                        {viewMode === 'continuous' ? (
                                            Array.from({ length: numPages }, (_, i) => (
                                                <div key={i} style={{ marginBottom: 12 }}>
                                                    <Page
                                                        pageNumber={i + 1}
                                                        width={PAGE_BASE_WIDTH * zoom - 20}
                                                        renderTextLayer={false}
                                                        renderAnnotationLayer={false}
                                                    />
                                                </div>
                                            ))
                                        ) : (
                                            <div>
                                                <Page
                                                    pageNumber={pageNumber}
                                                    width={PAGE_BASE_WIDTH * zoom - 20}
                                                    renderTextLayer={false}
                                                    renderAnnotationLayer={false}
                                                />
                                            </div>
                                        )}
                                    </Document>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    position="center"
                    message={toastMessage}
                />
            )}
        </>
    );
};

export default NoticeBoradPdfDetail;
